import React from 'react';
import HarcamaFormu from '../components/HarcamaFormu';

// Basit harcama giriş ekranı (YETK_WEB_9): sadece form, liste yok.
// Formun kendisi components/HarcamaFormu.js içindedir; "Harcama Kaydı Gelişmiş"
// ekranı da aynı bileşeni popup içinde kullanır.
export default function HarcamaKaydi() {
  return (
    <div style={{ maxWidth: 640, margin: '0 auto' }}>
      <h2 style={{ marginBottom: 4, color: 'var(--med-dark)' }}>💳 Yeni Harcama Kaydı</h2>
      <p style={{ color: 'var(--text-muted)', marginBottom: 20 }}>
        Kayıt, giriş yaptığınız şubenin veritabanına işlenir ve çıkış kasasının bakiyesini düşürür.
      </p>

      <div className="card">
        <HarcamaFormu />
      </div>
    </div>
  );
}
